module.exports = "<div class=\"bg-round\">\n\t<app-contact-infos></app-contact-infos>\n</div>\n<app-services-block></app-services-block>\n"


//////////////////
// WEBPACK FOOTER
// /Users/henriquezanini/Sites/Cães e Gatos/site/src/app/contact/contact.component.html
// module id = ../../../../../src/app/contact/contact.component.html
// module chunks = main